import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../utils/axiosSetup.js';
import Swal from 'sweetalert2';
import { closeModal } from '../../../action/modalbehaviour.js';

const EditAssignProject = ({ projectId, list }) => {
    const [projectData, setProjectData] = useState({});
    const [employees, setEmployees] = useState([]);
    const [department, setDepartment] = useState(null);
    const [selectAll, setSelectAll] = useState(false);
    const [assignedEmployees, setAssignedEmployees] = useState([]);
    const [selectedEmployees, setSelectedEmployees] = useState([]);

    const fetchProjects = async (Id) => {
        try {
            const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/assign_project/${Id}`);
            const data = response.data.data;
            setProjectData(data);
            setAssignedEmployees(data.employees.map(emp => parseInt(emp)));
            setDepartment(data.department_id);

            setSelectedEmployees([]);
            setSelectAll(false);
        } catch (error) {
            console.error(error);
            setProjectData({});
            setAssignedEmployees([]);
            setDepartment(null);
        }
    }

    const fetchEmployees = async () => {
        try {
            const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/users?users=all`);
            setEmployees(response.data.data);
        } catch (error) {
            console.error("Error fetching employees!", error);
            setEmployees([]);
        }
    };

    useEffect(() => {
        if (projectId) {
            fetchProjects(projectId);
        }
        fetchEmployees();
    }, [projectId]);

    useEffect(() => {
        const modalElement = document.getElementById(`edit_assign_project_${projectId}`);

        const handleClose = () => {
            fetchProjects(projectId);
        };

        if (modalElement) {
            modalElement.addEventListener('hidden.bs.modal', handleClose);
        }
        
        return () => {
            if (modalElement) {
                modalElement.removeEventListener('hidden.bs.modal', handleClose);
            }
        };
    }, [projectId]);

    const filteredEmployees = department 
        ? employees.filter(employee => parseInt(employee.department_id) === parseInt(department)) 
        : [];

    const handleEmployeeChange = (id, isChecked) => {
        if (isChecked) {
            setSelectedEmployees(prev => [...prev, id]);
        } else {
            setSelectedEmployees(prev => prev.filter(employeeID => employeeID !== id));
        }
    }

    const handleSelectAllChange = (isChecked) => {
        if (isChecked) {
            setSelectedEmployees(filteredEmployees
                .filter(employee => !assignedEmployees.includes(employee.id))
                .map(employee => employee.id)
            );
        } else {
            setSelectedEmployees([]);
        }
        setSelectAll(isChecked);
    }

    const handleFormSubmit = async () => {
        try {
            const response = await axiosInstance.post(`${process.env.REACT_APP_API_URL}/assign_project/${projectId}`, {
                employees: selectedEmployees
            });

            Swal.fire({ icon: "success", text: response.data.message });
            closeModal(`edit_assign_project_${projectId}`);
            list();
        } catch (error) {
            Swal.fire({ text: error.response?.data?.message || "An error occurred", icon: "error" });
        }
    }

    if (!projectId || !projectData) {
        return null;
    }

    return (
        <div id={`edit_assign_project_${projectId}`} className="modal custom-modal fade" role="dialog">
            <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Edit Assigned Project</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Channel</label>
                                        <input className="form-control" type="text" value={projectData.channel || ""} disabled />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Client</label>
                                        <input className="form-control" type="text" value={projectData.client || ""} disabled />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Project</label>
                                        <input className="form-control" type="text" value={projectData.project || ""} disabled />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Department</label>
                                        <input className="form-control" type="text" value={projectData.department || ""} disabled />
                                    </div>
                                </div>

                                <div className="table-responsive m-t-15">
                                    <table className="table table-striped custom-table">
                                        <thead>
                                            <tr>
                                                <th>Employees</th>
                                                <th className="text-center">
                                                    {filteredEmployees.length > 0 &&
                                                        <>
                                                            Select All &nbsp;&nbsp;
                                                            <input type="checkbox" 
                                                                checked={selectAll}
                                                                onChange={(e) => handleSelectAllChange(e.target.checked)}
                                                            />
                                                        </>
                                                    }
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredEmployees.length > 0 ? (
                                                filteredEmployees.map((employee) => (
                                                    <tr key={employee.id}>
                                                        <td>{employee.name}</td>
                                                        <td className="text-center">
                                                            <label className="custom_check">
                                                                <input
                                                                    type="checkbox"
                                                                    onChange={(e) => handleEmployeeChange(employee.id, e.target.checked)}
                                                                    checked={selectedEmployees.includes(employee.id) || assignedEmployees.includes(employee.id)}
                                                                    disabled={assignedEmployees.includes(employee.id)} // Disable if already assigned
                                                                />
                                                                <span className="checkmark"></span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td className="text-center" colSpan="2">No employee found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="submit-section">
                                <button type="button" onClick={handleFormSubmit} className="btn btn-primary submit-btn">SUBMIT</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EditAssignProject